module.exports = __webpack_public_path__ + "img/logo-ispace-legal.5984cfab.svg";